export enum ResponseFormats {
  JSON = 'JSON',
  XML = 'XML',
  TEXT = 'TEXT',
}
